import React, { Fragment } from 'react';
import { Button, Card, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { userLanguage } from '../../../../core/AuthContext';
import { GQLMerchantChannelProduct, GQLPricePiece } from '@jewelutions/core-crm-server-api-client-domain';
import { Money } from '@jewelutions/core-common-domain';
import { ImageCarousel } from '../../../../components';
import { Box } from '../../../../types-hack';

interface IProps {
  product: GQLMerchantChannelProduct;
}

const ProductCard: React.FC<IProps> = ({ product }: IProps) => {
  const { t: translate } = useTranslation();

  const currency = product.pieceVariants[0].retailPrice.currency;
  const piecePrices = product.pieceVariants.map(v => v.retailPrice.amount);
  const accessoryPrices = product.accessoryVariants.map(v => v.retailPrice.amount);

  const pieceRetailMargins = product.pieceVariants.map(v => v.retailPrice.amount / v.acquisitionPrice.amount);
  const accessoryMargins = product.accessoryVariants.map(
    v => v.retailPrice.amount / v.acquisitionPrice.amount
  );

  const computeAverageRetailMargin = (individualRetailMargins: number[]) => {
    return parseFloat(
      individualRetailMargins.reduce((a, b) => a + b, 0) / individualRetailMargins.length + ''
    ).toFixed(2);
  };

  return (
    <Fragment>
      <Grid item xs={12} md={4}>
        <Card variant="outlined">
          <Box pl={5} pt={5}>
            <Grid container direction="row" justify="space-between">
              <Grid item>
                <Typography gutterBottom variant="h6">
                  {product.title[userLanguage]}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box>
            <ImageCarousel
              images={product.pieceVariants.map(pieceVariant => pieceVariant.image.media.url!)}
            />
            <p style={{ color: 'grey' }}>
              Piece variants:
              <span style={{ color: 'black' }}>{product.pieceVariants?.length}</span>
            </p>
            <p style={{ color: 'grey' }}>
              Accessory variants:
              <span style={{ color: 'black' }}>{product.accessoryVariants?.length}</span>
            </p>
            <p style={{ color: 'grey' }}>
              Retail price margin:
              <span style={{ color: 'black' }}>
                Piece = {computeAverageRetailMargin(pieceRetailMargins)} | Accessories ={' '}
                {computeAverageRetailMargin(accessoryMargins)}
              </span>
            </p>
            <p style={{ color: 'grey' }}>
              Retail price range:
              <span style={{ color: 'black' }}>
                {Math.min(...piecePrices) + Math.min(...accessoryPrices)} -{' '}
                {Math.max(...piecePrices) + Math.max(...accessoryPrices)} {currency}
              </span>
            </p>
          </Box>
        </Card>
      </Grid>
    </Fragment>
  );
};

export default ProductCard;
